import { GetterTree } from "vuex";
import { IDepartment } from "@/core/interfaces/department.interface";
import { IDepartmentState } from "../types";
import { StoreState } from "@/store/type";

const getters: GetterTree<IDepartmentState, StoreState> = {
  departments: (state): IDepartment[] => state.departments || [],
  isFetchingDepartments: (state): boolean => state.isFetchingDepartments,
  departmentActionLoading: (state): boolean => state.departmentActionLoading,
};

export default getters;
